import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import AppHeader2 from './AppHeader2';

class Failure extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        LOADING: true, 
      };
    }

    render() {

      let AppHeaderClass = 'appHeader bg-dark text-light';
      let AppHeaderLeft = '';
      let AppHeaderLeftLink = '';
      let AppHeaderTitle = 'Transaction Failed';
      let AppHeaderRight = '';
      let AppHeaderRightLink = '';
      let AppHeaderSearch = '';

      return (
        <div>
            <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
            <div id="appCapsule">
              <div>
                <br />
                <br />
                <br />
                <div className="row">
                  <div className="col-2"></div>
                  <div className="col-8 align-content-center">
                    <center>
                      <h4>Transaction Failed. Please try again</h4>
                      <br />
                      <Link to="/cart" class="btn btn-outline-danger" type="button">
                        Back
                      </Link>
                    </center>
                  </div>
                  <div className="col-2"></div>
                </div>
              </div>
            </div>
        </div>
    );
    }
  }
  
  export default Failure;


// WEBPACK FOOTER //
// ./src/components/Failure.js